import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { LlmClient } from "../models/LlmClient";

export const useCreateLlmClient = () => {
  const {
    data: isCreated,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const createLlmClient = async (
    llmName: string,
    clientData: LlmClient & { clientName: string },
  ) => {
    await call(`/admin/llm/${llmName}/clients`, "POST", undefined, clientData);
  };

  return {
    createLlmClient,
    isCreated,
    isLoading,
    isFailed,
  };
};
